/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  primaryKey: 'id',
});
